import type { LayoutToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useLayoutTokens = (theme: Theme): LayoutToken => {
  const { color, component } = theme;
  const base = {
    textColor: color.surface,
    backgroundColor: color.onSurface,
    sidebarColor: color.background,
  };

  return merge({}, base, component?.layout) as LayoutToken;
};
